import React from 'react';
import clsx from 'clsx';
import { makeStyles} from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import {CssBaseline, Typography, IconButton, Dialog, withStyles, Button} from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HistoryIcon from '@material-ui/icons/History';
import StoreIcon from '@material-ui/icons/Storefront';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import PolicyIcon from '@material-ui/icons/Policy';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import fire from './fire'
import {isMobileOnly , isMobile} from 'react-device-detect';
import HistoryView from './profileView/historyView';
import ShipperView from './profileView/shipperView';
import SellerView from './profileView/sellerView';

const barWidth = () => {
    if (isMobile) return '100vw'
    else return '70vw'
  }
const renderWidth = () => {
    if (isMobileOnly) return '40vw'
    else return '15vw'
}

const renderDrawer = () => {
    if (isMobileOnly) return '40vw'
    else return '0'
}

const renderMargin = () => {
    if (isMobileOnly) return 220
    else return 0
}

const drawerWidth = renderDrawer() ;

const useStyles = makeStyles(theme => ({
    ContentBackground:{
        justifyContent: 'center',
        backgroundColor: '#282c34',
        height: '90vh',
        display: 'flex',
        width:'100vw',
        margin: 0,
        padding: 0,
      },
  
      roots:{
        width: barWidth(),
        height: '90vh', 
        display: 'flex',
        margin: 0,
        padding: 0
      },
  list: {
    width: renderWidth(),
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: barWidth(),
    height: '10vh', 
    margin: 0,
    padding: 0
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth})`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
 
  },
  grow: {
    flexGrow: 1,
  },
  content: {
    width: barWidth(),
    overflow: 'auto',
    height: '80vh',
    backgroundColor: 'white',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: renderMargin(),
  },
}));

const styles = theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    
  });

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });
  
const DialogContent = withStyles(theme => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);

export default function Profile() {
  const classes = useStyles();
  const [view, setView] = React.useState(0);
  const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
  
  const [state, setState] = React.useState({
    left: false,
  });

  const soundEffect = new Audio();

  const toggleDrawer = (side, open) => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [side]: open });
  };
  const handleChange = value => event => {
      event.preventDefault();
      if (value === 1 || value === 2) soundEffect.play()
      setView(value);
  }  

  function renderView(){
      switch(view){
        case 0:
            return <HistoryView fire = {fire} />;
        case 1:
          return <SellerView fire ={fire} soundAudio = {soundEffect}/>;
        case 2:
            return <ShipperView fire={fire} soundAudio = {soundEffect}/> ;
        case 3:
            return false;
        case 4:
            return false;
        default:
            return false;
      }
  }

  function textTitle () {
    switch(view){
    case 0:
        return 'History';
    case 1:
        return 'Seller';
    case 2:
        return 'Shipper';
    case 3:
        return 'Contact Us';
    case 4:
        return 'Policy';
    default:
        return false;
    }
  }

  const sideList = side => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        <ListItem button onClick={handleChange(0)}>
        <ListItemIcon>
          <HistoryIcon />
        </ListItemIcon>
        <ListItemText primary="History" />
      </ListItem>
      <Divider/>
      <ListItem button onClick={handleChange(1)}>
        <ListItemIcon>
          <StoreIcon />
        </ListItemIcon>
        <ListItemText primary="Seller" />
      </ListItem>
      <Divider/>
      <ListItem button onClick={handleChange(2)}>
        <ListItemIcon>
          <DriveEtaIcon />
        </ListItemIcon>
        <ListItemText primary="Shipper" />
      </ListItem>
      <Divider/>
      <ListItem button onClick={handleChange(3)}>
        <ListItemIcon>
          <ContactSupportIcon />
        </ListItemIcon>
        <ListItemText primary="Contact" />
      </ListItem>
      <Divider/>
      <ListItem button onClick={handleChange(4)}>
        <ListItemIcon>
          <PolicyIcon />
        </ListItemIcon>
        <ListItemText primary="Policy" />
      </ListItem>
      </List>
    </div>
  );

  const [showBank, setShow] = React.useState(false)
  const showBankDetail = () => event => {
      event.preventDefault();
      setShow(true);
    }
  const handleClose = () => setShow(false)

  return (
    <div className= {classes.ContentBackground}>
    <div className={classes.root}>
      <AppBar
        style ={{width: barWidth()}}
        position="static"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: state.left,
        })}
      >
        <Toolbar position='static'>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer('left', true)}
            edge="start"
            className={clsx(classes.menuButton, state.left && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
                {textTitle()}
          </Typography>
          <div className={classes.grow}/>
          <Button variant ='contained' size ='large' onClick = {showBankDetail()}>
            Bank detail
          </Button>
        </Toolbar>
      </AppBar>
      <SwipeableDrawer
        disableBackdropTransition={!iOS} 
        disableDiscovery={iOS}
        open={state.left}
        onClose={toggleDrawer('left', false)}
        onOpen={toggleDrawer('left', true)}
      >
        {sideList('left')}
      </SwipeableDrawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: state.left,
        })}
      >
        {renderView()}
      </main>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={showBank}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}></DialogTitle>
        <DialogContent >
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableBody>
            <TableRow>
            <TableCell>
                Name:
            </TableCell>
            <TableCell>
                BimBim
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell>
                BSB:
            </TableCell>
            <TableCell>
                065004
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell>
                Account No:
            </TableCell>
            <TableCell>
                11153942
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell>
                Message:
            </TableCell>
            <TableCell>
                "Shop Name - Your Name"
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell/>
            <TableCell>
                OR
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell>
                PayID: 
            </TableCell>
            <TableCell>
                0404496478
            </TableCell>
            </TableRow>
                </TableBody>
                </Table>
            </TableContainer>
            </DialogContent>
        </Dialog>
      <CssBaseline />
    </div>
    </div>
  );
}